'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var configure = require('../lib/configure.js');

var multipartRequest = require('ipfs-core-utils/multipart-request');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var abortSignal = require('../lib/abort-signal.js');

var createPut = function createPut(codecs, options) {
  var fn = configure.configure(function (api) {
    var put =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dagNode) {
        var options,
            settings,
            serialized,
            storeCodec,
            controller,
            signal,
            res,
            data,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                settings = _objectSpread({
                  storeCodec: 'dag-cbor',
                  hashAlg: 'sha2-256'
                }, options);

                if (!settings.inputCodec) {
                  _context.next = 8;
                  break;
                }

                if (dagNode instanceof Uint8Array) {
                  _context.next = 5;
                  break;
                }

                throw new Error('Can only inputCodec on raw bytes that can be decoded');

              case 5:
                serialized = dagNode;
                _context.next = 13;
                break;

              case 8:
                _context.next = 10;
                return codecs.getCodec(settings.storeCodec);

              case 10:
                storeCodec = _context.sent;
                serialized = storeCodec.encode(dagNode);
                settings.inputCodec = settings.storeCodec;

              case 13:
                controller = new AbortController();
                signal = abortSignal.abortSignal(controller.signal, settings.signal);
                _context.t0 = api;
                _context.t1 = _objectSpread;
                _context.t2 = {
                  timeout: settings.timeout,
                  signal: signal,
                  searchParams: toUrlSearchParams.toUrlSearchParams(settings)
                };
                _context.next = 20;
                return multipartRequest.multipartRequest([serialized], controller, settings.headers);

              case 20:
                _context.t3 = _context.sent;
                _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
                _context.next = 24;
                return _context.t0.post.call(_context.t0, 'dag/put', _context.t4);

              case 24:
                res = _context.sent;
                _context.next = 27;
                return res.json();

              case 27:
                data = _context.sent;
                return _context.abrupt("return", cid.CID.parse(data.Cid['/']));

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function put(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    return put;
  });
  return fn(options);
};

exports.createPut = createPut;